import { useUserProfile } from 'core/hooks/data/useDataHook'

const useComplianceProgram = () => {
  const { data: userProfile } = useUserProfile()
  return userProfile?.program ?? userProfile?.next_program
}

export default useComplianceProgram
